import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from "@/shared-components/icons/components/public/XIcon";
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import './styles/LogoutConfirmation.css'; // Import the CSS file

const LogoutConfirmation = ({ open, onClose, onConfirm }) => {
  return (
    <GenericPopup
      open={open}
      className="popup-confirm-logout-container_popup"
      opacity
    >
      <div className="ppopup-confirm-logout-container relative">
        <div className="popup-confirm-logout_header">
          <Text className="popup-confirm-logout_header-text">
            Log out
            <XIcon className="popup-confirm-logout_close" onClick={onClose} />
          </Text>
        </div>

        <Text className="popup-confirm-logout_text">
          Are you sure you want to log out?
        </Text>
      </div>
      <div className="popup-confirm-logout_buttons">
        <ContinueButton 
          onClick={() => {
            onConfirm(); // Call the confirm function
            onClose(); // Close the dialog
          }} 
          medium
          className="continue-button_two"
        >
          Log out
        </ContinueButton>
        <ContinueButton 
          onClick={onClose} 
          medium
          className="continue-button_two"
        >
          Cancel
        </ContinueButton>
      </div>
    </GenericPopup>
  );
};

export default LogoutConfirmation;
